import { CancelToken } from 'axios';
import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODUploadParams, IVODUploadResponse } from '~/Models/DTO/VideoOnDemand.models';

export const useRequestUploadVOD = (cancelToken?: CancelToken) => {
  const { currentProvider } = useProvider();

  const {
    data: vodUploadResponse,
    error: vodUploadError,
    isLoading: isVodVideoUploadLoading,
    mutate: uploadVideo,
    isSuccess: isVodVideoUploadSuccess,
  } = useMutation<IVODUploadResponse, IErrorResponse, IVODUploadParams>(
    async (params: IVODUploadParams) =>
      requestReactQuery<IVODUploadResponse>({
        url: VIDEO_INTEGRATION_SERVICE_URLS.VOD_UPLOADS,
        data: {
          videoId: params.videoId,
          corsOrigin: currentProvider?.domain,
        },
        config: { method: 'POST', cancelToken },
      }),
    { mutationKey: REQUEST_ACTIONS.UPLOAD_VOD_VIDEO },
  );

  return {
    vodUploadError: vodUploadError as IErrorResponse,
    vodUploadResponse,
    uploadVideo,
    isVodVideoUploadLoading,
    isVodVideoUploadSuccess,
  };
};
